import { Products } from 'merchandise-lib/constants/Product';
import * as BundleTypes from 'self-service-api/constants/BundleTypes';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
import { ENTERPRISE, STARTER, tabIdToProductLevels } from '../../v2/constants/Tabs';
import { isValidTier } from '../../v2/utils/typeguards';
const tabIdToSuiteApiNameMap = {
  [STARTER]: [Products.HUBSPOT_FREE, Products.CRM_SUITE_STARTER_BUNDLE, Products.CRM_SUITE_PROFESSIONAL_BUNDLE],
  [ENTERPRISE]: [Products.CRM_SUITE_PROFESSIONAL_BUNDLE, Products.CRM_SUITE_ENTERPRISE_BUNDLE]
};
export const getMerchCardsToShow = ({
  tab,
  tier,
  isUngatedForPublicRemoveTabs
}) => {
  // When tabs are removed via feature flag, use tier param to determine which cards to show
  // Default (no tier param): Show all 4 cards
  // tier='enterprise' (case-insensitive): Show only Professional and Enterprise cards
  if (isUngatedForPublicRemoveTabs) {
    return isValidTier(tier) ? ['PROFESSIONAL', 'ENTERPRISE'] : ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
  }

  // Legacy tab-based filtering
  return tab ? tabIdToProductLevels[tab] : ['STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
};
export const getMobileMerchCardsToShow = bundleType => {
  switch (bundleType) {
    case BundleTypes.NONE:
      return [];
    case BundleTypes.CRM_SUITE:
      return [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
    case BundleTypes.MARKETING_PLUS_SUITE:
      return [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
    default:
      {
        return [ProductLevels.FREE, ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
      }
  }
};
export const getApiNamesToShowForBundle = ({
  bundleType,
  tab
}) => {
  switch (bundleType) {
    case BundleTypes.CRM_SUITE:
      return tab ? tabIdToSuiteApiNameMap[tab] : [Products.CRM_SUITE_STARTER_BUNDLE, Products.CRM_SUITE_PROFESSIONAL_BUNDLE, Products.CRM_SUITE_ENTERPRISE_BUNDLE];
    case BundleTypes.NONE:
    default:
      return [];
  }
};